export function buildMetaInfo({ title, description, socialImage, ...metaInfo }: {
  title?: string;
  description?: string;
  socialImage?: string;
  link?: { rel: string; href: string }[];
  meta?: { name: string; content: string }[];
}) {
  const titleMeta = [
    { name: 'og:title', content: title },
    { name: 'twitter:title', content: `FreelanceRepublik - ${title}` },
  ];
  const descriptionMeta = [
    { name: 'description', content: description },
    { name: 'og:description', content: description },
    { name: 'twitter:description', content: description },
  ];
  const socialImageMeta = [
    { name: 'og:image', content: socialImage },
    { name: 'twitter:image', content: socialImage },
  ];

  return {
    ...metaInfo,
    title,
    meta: [
      ...(title ? titleMeta : []),
      ...(description ? descriptionMeta : []),
      ...(socialImage ? socialImageMeta : []),
      ...(metaInfo.meta || []),
    ],
  };
}
